<template>
  <div class="widget">
    <div class="widget-header">
      {{ $t('order.title') }}
    </div>
    <div class="widget-body card-body">
      <Order />
    </div>
  </div>
</template>
<script>

import Order from './Order'

export default {
  name: 'Card',
  components: {
    Order
  },
  props: {
    order: {
      type: Object,
      default: () => ({
      })
    },
  },
  data() {
    return {
    };
  },
  methods: {

  },
};
</script>

<style scoped>
@media only screen and (min-width: 992px) {
  .card-body {
    max-width: 60%
  }
}
</style>


// WEBPACK FOOTER //
// src/components/order/Card.vue